export default "__VITE_ASSET__D9vTpC4g__"